
import { ButtonBase, IconButton, Tooltip } from "@mui/material";
import Markdown from "../../components/Markdown";
import { DeleteOutline, Edit } from "@mui/icons-material";
import { getGridContextMenuList } from "../../_helpers/getGridContextMenuList";
import { LOCAL_STORAGE_GRID_KEYS } from "../../_constants";
import { LabelColumnV2 } from "../../components/DataGridV2/DataColumnsV2";

export const getStandardTextManagerColumns = ({
  t,
  i18n,
  apiRef,
  keyPrefix,
  handleClose,
  onSelect,
  classes,
  handleDelete,
  handleEdit
}) => {
  const getOptions = getGridContextMenuList({
    filterKey: LOCAL_STORAGE_GRID_KEYS.STANDARD_TEXT_MANAGER_COLUMN_FILTER[keyPrefix],
    sortKey: LOCAL_STORAGE_GRID_KEYS.STANDARD_TEXT_MANAGER_COLUMN_SORT[keyPrefix],
    i18n,
    t,
    apiRef,
    mode: "client"
  })
  return [
      {
        field: "hashtag",
        download: true,
        print:true,
        headerName: "#hashtag",
        flex: 1,
        minWidth: 90,
        renderCell: (params) => {
          const rowData = params?.row;
          if (!rowData) return "";
          return (
            <LabelColumnV2 
              label={'#' + rowData.hashtag}
              request={rowData}
              cellSubMenuOptions={{ options: getOptions({ field: "hashtag", isQuickFilterDisplay: Boolean(rowData.hashtag) }), extraData: { fieldName: "hashtag"}}}
            />
          )
        },
      },
      {
        field: "textBlock",
        download: true,
        print:true,
        headerName: t('chat.standardText.text.label'),
        flex: 1,
        filterable:false,
        minWidth: 90,
        renderCell: (params) => {
          const rowData = params?.row;
          if (!rowData) return "";
          return (
             <ButtonBase
                className={classes.markdownBlock}
                component="div"
                focusRipple
                onClick={() => {
                  onSelect(rowData.textBlock);
                  handleClose();
                }}
              >
                <Markdown value={rowData.textBlock} />
              </ButtonBase>
          )
        },
      },
      {
        field: "action",
        download: false,
        print:false,
        headerName: t('general.action'),
        flex: 1,
        minWidth: 90,
        renderCell: (params) => {
          const rowData = params?.row;
          if (!rowData) return "";
          return (
            <LabelColumnV2
              label={
                <>
                  <Tooltip title={t("chat.standardText.change")}>
                    <IconButton className={classes.iconButton} size="small" color="primary" aria-label="edit" onClick={() => handleEdit(rowData?.id)}>
                      <Edit fontSize="small" />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title={t("general.delete")}>
                    <IconButton className={classes.iconButton} size="small" color="primary" aria-label="delete" onClick={() => handleDelete(rowData.id)}>
                      <DeleteOutline fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </>
              }
            />
            );
        },
      },
    ];;
}


